import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hasTooltip", "stepKey", "message", "className", "children", "tooltipLink", "shouldShowDefault", "isFramedCentredStep"];
import { useSelector } from 'react-redux';
import { Industry } from 'signup-ui-lego-core/constants/Industry';
import styled from 'styled-components';
import { H2 } from 'UIComponents/elements/headings';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import { devices } from 'signup-constants/styles/viewports.styles';
import { getStepTitle } from '../utils/getStepTitle';
import { Step } from 'signup-constants/Step';
import { OptionalFormattedMessage } from './OptionalFormattedMessage';
import { TitleTooltip } from './TitleTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TITLE_CENTERED_STEPS = [Step.ExistingUser, Step.Verification, Step.CodeVerification, Step.GoogleContactsSync];
const StyledStepTitle = styled(H2).withConfig({
  displayName: "StepTitle__StyledStepTitle",
  componentId: "we7w67-0"
})(["font-size:2rem;font-weight:700;", " ", " @media ", "{", " ", " ", " ", " ", "}"], props => TITLE_CENTERED_STEPS.includes(props.stepKey) && `text-align: center;`, props => props.theme.embedded && `margin-top: 20px;
  text-align: center;
  font-size: 1.75rem;`, devices.desktop, props => props.isFramedCentredStep && 'line-height: 45px;', props => props.isFramedCentredStep && props.stepKey !== Step.Password && props.stepKey !== Step.GoogleContactsSync && `padding-left: 50px;
    padding-right: 50px;`, props => props.isFramedCentredStep && props.stepKey === Step.JobRole && `padding-left: 75px;
      padding-right: 75px;`, props => props.isFramedCentredStep && (props.stepKey === Step.OptionalPhoneNumber || props.stepKey === Step.PhoneNumber || props.isRealEstateIndustry) && `padding-left: 35px;
        padding-right: 35px;`, props => (props.stepKey === Step.ProblemAwareness || props.stepKey === Step.ProductExperience) && `
          max-width: 820px;
          margin-left: auto;
          margin-right: auto;
        `);
export const StepTitle = _ref => {
  let {
      hasTooltip = false,
      stepKey,
      message = null,
      className = '',
      children,
      tooltipLink,
      shouldShowDefault = true,
      isFramedCentredStep = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const title = useSelector(getStepTitle);
  const classNames = `${stepKey} ${className}`;
  const {
    data: industry
  } = useSignupData(Data.Industry);
  const isRealEstateIndustry = industry === Industry.RealEstate;
  return /*#__PURE__*/_jsxs(StyledStepTitle
  // @ts-expect-error Expression produces a union type that is too complex to represent.
  , Object.assign({
    className: classNames,
    isFramedCentredStep: isFramedCentredStep,
    isRealEstateIndustry: isRealEstateIndustry,
    stepKey: stepKey
  }, rest, {
    children: [shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      message: message || title
    }), hasTooltip && stepKey && tooltipLink && /*#__PURE__*/_jsx(TitleTooltip, {
      stepKey: stepKey,
      tooltipLink: tooltipLink
    }), children]
  }));
};